module.exports = __webpack_public_path__ + "img/kep2-5.13cc033c.jpg";